import React, { useEffect, useState } from 'react'

import { Badge } from '@material-ui/core'

import { useAddRemovePropertyForms } from '../hooks/useAddRemovePropertyForms'
import { useUser } from '../hooks'

const FormsPendingBadge: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const [pendingCount, setPendingCount] = useState(0)

    const { organization } = useUser()

    const { getPendingFormCount } = useAddRemovePropertyForms(organization)

    useEffect(() => {
        getPendingFormCount().then((count) => {
            setPendingCount(count)
        })
    }, [])

    return (
        <Badge
            badgeContent={pendingCount || 0}
            color="error"
            invisible={!pendingCount}
        >
            {children}
        </Badge>
    )
}

export default FormsPendingBadge
